"use strict";
/**
 * video视频相关ts
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoPositionCtrl = exports.simuCheckAuth42110 = exports.simuCheckAuth42000 = exports.toCepingfun = exports.subbaoming = exports.subchecktip = exports.getYYPermissionAction = exports.anthenticFun = exports.toAuthfun = exports.toUidCheckfun = exports.EncrollFun = exports.getyyLabel = exports.reducer = exports.initalstate = void 0;
var toastmodal_1 = __importDefault(require("../../../../modules/modal/toastmodal"));
var luyan_1 = require("../../../../modules/api/luyan");
// import { luyanstore } from "../store";
// import warmming from "../../../../modules/modal/toastmodal";
var ceping_1 = require("../../../../modules/ceping");
var lodash_1 = __importDefault(require("lodash"));
var user_1 = __importDefault(require("../../../../modules/user"));
exports.initalstate = {
    showVideo: false,
    havePlaysrc: false,
    showmask: false,
    showlefttime: true,
    showRoomLabel: true,
    freshkey: 0,
    videoid: "lyav-player-ctx",
    rtcRoomInfo: {
        rtc_enable: true,
        rtc_status: 1,
        rtc_live_addr: "",
        dbg_code: ""
    },
    showcoverimg: true,
    showyuyuebtn: true,
    showvoicewave: false // 展示音频直播音浪动画
};
function reducer(state, action) {
    switch (action.type) {
        case "显示房间号标签":
            return __assign(__assign({}, state), { showRoomLabel: true });
        case "隐藏房间号标签":
            return __assign(__assign({}, state), { showRoomLabel: false });
        case "显示视频":
            return __assign(__assign({}, state), { showVideo: true });
        case "隐藏视频":
            return __assign(__assign({}, state), { showVideo: false });
        case "有视频地址":
            return __assign(__assign({}, state), { havePlaysrc: action.payload.havePlaysrc });
        case "显示遮罩层":
            return __assign(__assign({}, state), { showmask: true });
        case "隐藏遮罩层":
            return __assign(__assign({}, state), { showmask: false });
        case "展示倒计时":
            return __assign(__assign({}, state), { showlefttime: action.payload.showlefttime });
        case "刷新视频区":
            return __assign(__assign({}, state), { freshkey: state.freshkey + 1 });
        case "播放器id":
            return __assign(__assign({}, state), { videoid: action.payload.videoid });
        case "测试直播间信息":
            return __assign(__assign({}, state), { rtcRoomInfo: action.payload.rtcRoomInfo });
        case "显示封面":
            return __assign(__assign({}, state), { showcoverimg: action.payload.showcoverimg });
        case "展示预约按钮":
            return __assign(__assign({}, state), { showyuyuebtn: action.payload.showyuyuebtn });
        case "展示音频音浪动画":
            return __assign(__assign({}, state), { showvoicewave: action.payload.showvoicewave });
        default:
            throw new Error();
    }
}
exports.reducer = reducer;
;
/**
* 获取预约状态标签
*  @param {number} enrollstatus
 * @param {number} authstatus
 * @param {number} sourcetype 有没有视频
 * @returns
 */
function getyyLabel(enrollstatus, authstatus) {
    var chechstr = "预约";
    //只要提交过认证都可报名
    if ((authstatus == 1 || authstatus == 2 || authstatus == 3) && enrollstatus == 0) {
        // chechstr = "认证审核中，我要报名"
        chechstr = "报名观看";
    }
    ;
    var btnobj = {
        class: "",
        rightBtnClass: "",
        txt: ""
    };
    switch (enrollstatus) {
        case 0:
            btnobj = {
                class: "ly-yy0",
                rightBtnClass: "",
                txt: chechstr
            };
            break;
        case 1:
            btnobj = {
                class: "ly-yy1",
                rightBtnClass: "",
                txt: "报名成功"
            };
            break;
        case 2:
            btnobj = {
                class: "ly-yy2",
                rightBtnClass: "bt1",
                txt: "已报名，审核中..."
            };
            break;
        case 3:
            btnobj = {
                class: "ly-yy3",
                rightBtnClass: "bt1",
                txt: "报名失败"
            };
            break;
    }
    return btnobj;
}
exports.getyyLabel = getyyLabel;
/**
 * 报名or认证 逻辑
 * @param status
 * @param authstatus
 * @param enstatus
 * @param faildcb
 * @returns
 */
var EncrollFun = function (status, authstatus, enstatus, faildcb) {
    // 0 未提交认证
    if (authstatus == 0) {
        anthenticFun(); //跳转认证
    }
    else if (authstatus == 1 || authstatus == 2 || authstatus == 3) {
        // enstatus 报名状态 0:未提交报名 1：报名通过 2：报名待审核 3：报名审核不通过
        if (enstatus == 0) {
            // that.subbaoming(null, callbackfun);
            (0, exports.subbaoming)(false, function () { });
            return false;
        }
        // 2：报名待审核
        if (enstatus == 2) {
            (0, exports.subchecktip)();
            return false;
        }
        // 3：报名审核不通过
        if (enstatus == 3 || enstatus == 1) {
            if (enstatus == 3 && status != 4) {
                toastmodal_1.default.init({
                    tipinfos: "报名失败"
                });
                return;
            }
            else {
                // dispatch({ type: "显示遮罩层" })
                faildcb && faildcb();
            }
        }
        return false;
    }
    else {
        return false;
    }
};
exports.EncrollFun = EncrollFun;
/**
 * 40101 权限验证
 * @param authinfo
 */
var toUidCheckfun = function (authinfo) {
    var _a;
    toastmodal_1.default.init({
        tipinfos: ((_a = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _a === void 0 ? void 0 : _a.notice) || '',
        subtext: "确定",
        iconname: "icon_check",
        showsubbtn: true,
        showcancelbtn: false,
        subcallback: function () { }
    });
};
exports.toUidCheckfun = toUidCheckfun;
/**
 * 机构认证 41000
 */
var toAuthfun = function (authinfo) {
    var _a, _b, _c;
    var uid = (_a = user_1.default.get()) === null || _a === void 0 ? void 0 : _a.id;
    if (!uid) {
        anthenticFun();
        return; //未登陆直接跳转到登陆
    }
    // authstatus 0: 未提交认证 1：认证通过 2：认证待审核 3：认证审核不通过
    var authstatus = (_b = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _b === void 0 ? void 0 : _b.auth_status;
    // enrollstatus   0:未提交报名 1：报名通过 2：报名待审核 3：报名审核不通过
    var enrollstatus = (_c = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _c === void 0 ? void 0 : _c.enroll_status;
    if (enrollstatus == 3 || enrollstatus == 1) {
        return false;
    } //报名成功or失败不可点
    if (authstatus == 0) { //未认证
        anthenticFun(); //跳转认证
    }
    //认证成功或认证审核中  可预约
    else if (authstatus == 1 || authstatus == 2 || authstatus == 3) { //3认证失败也报名
        // that.getYYPermissionAction(sourcetype, e, cbfun); //预约
        (0, exports.getYYPermissionAction)(enrollstatus);
    }
    //认证失败
    else {
        anthenticFun(); //跳转认证
        return false;
    }
    ;
};
exports.toAuthfun = toAuthfun;
/**
 * 跳转认证
 */
function anthenticFun() {
    var _a;
    var uid = (_a = user_1.default.get()) === null || _a === void 0 ? void 0 : _a.id; //用户uid
    if (uid) {
        self.open("/authentic");
    }
    else {
        self.location.href = "https://passport2.eastmoney.com/pub/login?backurl=" + encodeURIComponent(self.location.href);
    }
}
exports.anthenticFun = anthenticFun;
/**
 * 预约报名
 */
var getYYPermissionAction = function (enroll_status) {
    //已报名审核中
    if (enroll_status == 2) {
        (0, exports.subchecktip)();
    }
    ;
    //未报名
    if (enroll_status == 0) {
        // alert("提交报名")
        (0, exports.subbaoming)(false, function () { });
    }
    ;
};
exports.getYYPermissionAction = getYYPermissionAction;
/**
 * 已报名 审核中
 */
var subchecktip = function () {
    toastmodal_1.default.init({
        tipinfos: "已报名，审核中",
        subtext: "确定",
        iconname: "icon_check",
        showsubbtn: true,
        showcancelbtn: false,
        subcallback: function () { }
    });
};
exports.subchecktip = subchecktip;
/**
 * 提交报名
 * @params sourcetype 有没有视频
 */
var subbaoming = function (sourcetype, callbackfun) {
    toastmodal_1.default.init({
        tipinfos: "是否报名获取观看直播权限",
        subtext: "立即报名",
        iconname: "icon_sub",
        showsubbtn: true,
        showcancelbtn: true,
        subcallback: function () {
            var _this = this;
            (0, luyan_1.UserEnroll)().then(function () { return __awaiter(_this, void 0, void 0, function () {
                var authinfos, enroll_status, auth_status;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, (0, luyan_1.getAuthInfos)()];
                        case 1:
                            authinfos = _c.sent();
                            enroll_status = (_a = authinfos === null || authinfos === void 0 ? void 0 : authinfos.data) === null || _a === void 0 ? void 0 : _a.enroll_status;
                            console.log("提交报名& enroll_status ：" + enroll_status);
                            auth_status = (_b = authinfos === null || authinfos === void 0 ? void 0 : authinfos.data) === null || _b === void 0 ? void 0 : _b.auth_status;
                            // that.enrollstatus = enroll_status;
                            // that.authinfo = authinfos; //全局
                            //成功回调
                            // if (callbackfun && enroll_status == 1) {
                            //   callbackfun()
                            //   return false
                            // };
                            // if (sourcetype !== null) {
                            //   //视频区内按钮标签
                            //   let yylabstr = getyyLabel(enroll_status, auth_status);
                            //   // $("#" + that.boxid).append($(yylabstr));
                            //   $("#lefttime-wrap").append($(yylabstr));
                            //   //聊天框内标签
                            //   let yystr = getPostAuthLab(authinfos);
                            //   $(".yy-wrap").find(".yybtn").remove();
                            //   $(".yy-wrap").append($(yystr));
                            // };
                            self.location.reload();
                            return [2 /*return*/];
                    }
                });
            }); });
        }
    });
};
exports.subbaoming = subbaoming;
/**
 * 测评
 * @param data
 * @param authinfo
 * @param cbfun
 */
var toCepingfun = function (data, authinfo, cbfun) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    // 直播测评
    if (((_a = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _a === void 0 ? void 0 : _a.status) == 1 && ((_b = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _b === void 0 ? void 0 : _b.view_type) == 4 && ((_d = (_c = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _c === void 0 ? void 0 : _c.whitelist_config) === null || _d === void 0 ? void 0 : _d.whitelist_type) == 4) {
        ceping_1.cepingDiff.zhiboCePing(authinfo, cbfun);
    }
    // 预告测评
    if (((_e = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _e === void 0 ? void 0 : _e.status) == 4 && ((_f = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _f === void 0 ? void 0 : _f.view_type) == 4 && ((_h = (_g = authinfo.data) === null || _g === void 0 ? void 0 : _g.whitelist_config) === null || _h === void 0 ? void 0 : _h.whitelist_type) == 4) {
        var cb = function () {
            self.location.reload();
        };
        ceping_1.cepingDiff.yugaoCePing(authinfo, cb);
    }
    // 回顾测评
    if (((_j = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _j === void 0 ? void 0 : _j.status) == 3 && ((_k = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _k === void 0 ? void 0 : _k.view_type) == 4 && ((_m = (_l = authinfo.data) === null || _l === void 0 ? void 0 : _l.whitelist_config) === null || _m === void 0 ? void 0 : _m.whitelist_type) == 4) {
        ceping_1.cepingDiff.huiguCePing(authinfo, cbfun); // 风险测评
    }
};
exports.toCepingfun = toCepingfun;
/**
 * 42000 私募权限
 */
var simuCheckAuth42000 = function () {
    toastmodal_1.default.init({
        tipinfos: "\u672C\u573A\u76F4\u64AD\u4EC5\u9650\u7279\u5B9A\u7528\u6237\u89C2\u770B\uFF0C\u8BF7\u5B8C\u6210\u7279\u5B9A\u5BF9\u8C61\u8BA4\u8BC1\u540E\u518D\u6B21\u8FDB\u5165\u3002\u7279\u5B9A\u5BF9\u8C61\u8BA4\u8BC1\u8BE6\u60C5\u8BF7\u54A8\u8BE295357\u8F6C6\u3002",
        subtext: "确定",
        iconname: "icon_check",
        showsubbtn: true,
        showcancelbtn: false,
        subcallback: function () { }
    });
};
exports.simuCheckAuth42000 = simuCheckAuth42000;
/**
 * 42110 私募+风险不通过
 */
var simuCheckAuth42110 = function (authinfo, cb) {
    var _a;
    var ainfo = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data, status = (_a = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _a === void 0 ? void 0 : _a.status;
    toastmodal_1.default.init({
        tipinfos: (ainfo === null || ainfo === void 0 ? void 0 : ainfo.notice) || "尊敬的投资人，您的风险承受能力低于该视频中提及的部分产品的风险等级，请确认是否继续观看视频详情。如果选择继续观看，代表您已完全知悉该视频提及的该产品的风险，并自愿承担后续决策风险。",
        subtext: "确定",
        iconname: "icon_check",
        showsubbtn: true,
        showcancelbtn: false,
        subcallback: function () {
            cb && cb();
        }
    });
};
exports.simuCheckAuth42110 = simuCheckAuth42110;
/**
 * 视频小窗口位置控制
 *
*/
function videoPositionCtrl(smalldom) {
    try {
        var sm_1 = smalldom;
        var offtop_1 = sm_1.offset().top;
        $(window).on("scroll", lodash_1.default.debounce(function () {
            var chatbox = $("#postchatbox");
            var _toppx = !chatbox.length ? 33 : 165;
            var scrolltop = $(document).scrollTop();
            if (scrolltop + 245 > offtop_1) {
                sm_1.css({ 'position': 'fixed', 'top': _toppx + 'px' });
            }
            else {
                sm_1.css({ 'position': '', "top": "" });
            }
        }, 5));
    }
    catch (error) {
    }
}
exports.videoPositionCtrl = videoPositionCtrl;
//# sourceMappingURL=data:application/json;base64,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